import { SYS_BORDER_RADIUS_MAX, SYS_BORDER_RADIUS_NONE, getMargins } from '@oneaudi/unified-web-common';
import styled, { keyframes } from 'styled-components';
const fadeInFadeOut = keyframes `
  0% {
    opacity: 1
  }

  50% {
    opacity: 0.4
  }

  100% {
    opacity: 1
  }
`;
export const StyledSkeleton = styled.div `
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  aspect-ratio: ${(props) => props.aspectRatio};
  background-color: ${(props) => props.theme.cmp.color.ui.skeleton.surface.fill};
  // TODO: Add motion token
  animation: ${fadeInFadeOut} 2s ease-in-out 0.5s infinite;
  cursor: progress;
  margin: ${(props) => getMargins(props.margin)};
  border-radius: ${(props) => props.variant === 'rectangular'
    ? SYS_BORDER_RADIUS_NONE
    : SYS_BORDER_RADIUS_MAX};
`;
//# sourceMappingURL=index.styles.js.map